<script setup>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

const props = defineProps([
    'classes',
    'url',
    'slides'
])

const options = {
    arrows: false,
    autoplay: true,
    pagination: true,
    type: 'loop'
}
</script>

<template>
    <div class="col-lg-3 col-md-6 col-sm-6 banner-column column slider" :class="classes">
        <Splide :options="options">
            <SplideSlide v-for="(slide, key) in slides" :key="key">
                <a :href="slide.url" class="link-box js-ga-event"
                   data-page-area="carousel"
                   data-type="image"
                   data-name="banner"
                   data-action="href"
                   :data-destination-url="slide.url"
                >
                    <picture>
                        <template v-if="slide.image_mobile">
                            <source media="(max-width: 575px)" :srcset="'/storage/' + slide.image_mobile">
                        </template>
                        <img :src="'/storage/' + slide.image" :alt="slide.image_alt">
                    </picture>
                    <div class="content">
                        <template v-if="slide.text">
                            <h4 :style="{ color: slide.text_color }">
                                {{ slide.text }}
                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.7475 9.26264L15.3602 6.64997C15.7844 6.2054 16.0212 5.61449 16.0212 4.99997C16.0212 4.38545 15.7844 3.79454 15.3602 3.34997L12.7475 0.737299C12.56 0.549702 12.3057 0.444276 12.0404 0.444214C11.7752 0.444151 11.5208 0.549458 11.3332 0.736966C11.1456 0.924474 11.0402 1.17882 11.0401 1.44406C11.04 1.7093 11.1454 1.9637 11.3329 2.1513L13.1862 4.0053L1.01953 4.02063C0.754315 4.02063 0.499961 4.12599 0.312424 4.31353C0.124888 4.50106 0.0195313 4.75542 0.0195312 5.02064V5.02064C0.0195313 5.28585 0.124888 5.54021 0.312424 5.72774C0.499961 5.91528 0.754315 6.02064 1.01953 6.02064L13.1735 6.0053L11.3329 7.84864C11.1507 8.03724 11.0499 8.28984 11.0522 8.55204C11.0545 8.81424 11.1596 9.06505 11.345 9.25046C11.5305 9.43587 11.7813 9.54103 12.0435 9.54331C12.3057 9.54559 12.5583 9.4448 12.7469 9.26264H12.7475Z"
                                          :fill="slide.text_color ?? '#474757'"
                                    />
                                </svg>
                            </h4>
                        </template>
                    </div>
                </a>
            </SplideSlide>
        </Splide>
    </div>
</template>
